import React from "react";
import {Settings} from "../Utils/Settings";

function SearchResultThumbnail(props) {
    let {image, caption} = props;
    if (image.length === 0) {
        image = Settings.subFolder + "Content/NoPhotoYet.jpg";
    }
    return <img src={image} alt={caption} style={{maxWidth: "100%", display: "block", maxHeight: "200px", borderRadius: ".25rem", width: "200px", margin: "0 auto"}} />
}

export default SearchResultThumbnail;